import { SelectField } from '@flos/react-ui';
import { type OptionProps } from '@flos/react-ui/build/core/forms/select/select-input';
import type { OPCTermDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { useHippoText } from '../../../../hooks/useHippoText';
import { formatStringToMonetaryValueString } from '../../../../utils/coverablesUtil';
import { useRecoilValue } from 'recoil';
import { isOpcFetchingAtom } from '../../../../recoil/atoms/isOpcFetchingAtom';

const AdjustDeductible = ({
    termInfo,
    updateTermValue,
    isAdjustableDataValid,
    overrideSubHeader,
    overrideErrorMsg
}: {
    termInfo: OPCTermDTO;
    updateTermValue: (termValue: number, publicId?: string) => void;
    isAdjustableDataValid: boolean;
    overrideSubHeader?: string;
    overrideErrorMsg?: string;
}): JSX.Element => {
    const getHippoText = useHippoText();
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const options: OptionProps[] = termInfo.options?.map((option) => ({
        label: formatStringToMonetaryValueString(String(option.code)),
        value: option.code
    })) as OptionProps[];

    const onCancellationDateChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const selectedIndex = event.target.selectedIndex;
        const { value } = event.target.options[selectedIndex];
        updateTermValue(Number(value), termInfo?.publicId);
    };

    const errorMsg = overrideErrorMsg
        ? getHippoText(overrideErrorMsg)
        : 'Du har valgt den samme selvrisiko, som du allerede har. Vælg en anden, eller klik fortryd.';

    return (
        <>
            <h6>
                {getHippoText(overrideSubHeader ?? 'DSS-COVERABLE-DETAILS-ADAPT-DEDUCTIBLE-INPUT')}
            </h6>
            <SelectField
                className="u-spacing-stack-none"
                options={options}
                placeholder={formatStringToMonetaryValueString(String(termInfo.value))}
                onChange={onCancellationDateChange}
                isValid={isAdjustableDataValid}
                errorText=""
                disabled={isOpcFetching}
            />
            {!isAdjustableDataValid && (
                <p className="paragraph--small u-color-supplement-error-base">{errorMsg}</p>
            )}
        </>
    );
};

export default AdjustDeductible;
